(() => {
  if (window.__novariaPodalivProductLoaded) return;
  window.__novariaPodalivProductLoaded = true;

  const preferredMediaOrder = [
    '37270021046425',
    '37270111060121',
    '37270111256729',
    '37270111289497',
    '37270111092889',
    '37270111191193',
    '37270111223961',
    '37270111125657',
    '37270111322265',
    '37270111158425'
  ];

  const mediaIdFrom = (node, attribute) => {
    const value = node?.getAttribute(attribute) || '';
    const match = value.match(/-(\d+)$/);
    return match ? match[1] : '';
  };

  const reorderList = (root, selector, attribute) => {
    const list = root?.querySelector(selector);
    if (!list || list.dataset.novariaOrdered === 'true') return;

    const items = Array.from(list.children);
    if (items.length < 2) return;

    const byId = new Map();
    items.forEach((item) => {
      const id = mediaIdFrom(item, attribute);
      if (id) byId.set(id, item);
    });

    const used = new Set();
    const fragment = document.createDocumentFragment();

    preferredMediaOrder.forEach((id) => {
      const item = byId.get(id);
      if (!item) return;
      fragment.appendChild(item);
      used.add(id);
    });

    items.forEach((item) => {
      const id = mediaIdFrom(item, attribute);
      if (!used.has(id)) fragment.appendChild(item);
    });

    list.appendChild(fragment);
    list.dataset.novariaOrdered = 'true';
  };

  const init = () => {
    document.querySelectorAll('product-info.nv-podaliv-main').forEach((root) => {
      reorderList(root, "[id^='Slider-Gallery-']", 'data-media-id');
      reorderList(root, "[id^='Slider-Thumbnails-']", 'data-target');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 60));
})();